import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, switchMap, tap } from 'rxjs';
import { GroupService } from './group.service';
import { PracticeSettingsStore } from './practice-settings-store.service';

/** The selected group's practice locations (tasks/practice-locations.md), loaded whenever the group changes. */
@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private apiUrl = 'api';
  private locationsSubject = new BehaviorSubject<any[] | null>(null);
  locations$ = this.locationsSubject.asObservable();

  groupId?: string;

  constructor(
    private http: HttpClient,
    private groupService: GroupService,
    private settingsStore?: PracticeSettingsStore,
  ) {
    this.groupService.selectedGroup$.pipe(
      switchMap(selectedGroup => {
        if (selectedGroup) {
          this.groupId = selectedGroup.id;
          return this.getLocationsByGroup(selectedGroup.id, true);
        }
        return EMPTY;
      })
    ).subscribe();
  }

  /** `fromKeptCopy`: on a practice switch, the device's kept copy while it is current (PracticeSettingsStore). */
  getLocationsByGroup(groupId: string, fromKeptCopy = false): Observable<any[]> {
    const token = localStorage.getItem('token');
    const request = this.http.get<any[]>(`${this.apiUrl}/locations/group/${groupId}`, { headers: { Authorization: `Bearer ${token}` } });
    const source = fromKeptCopy && this.settingsStore ? this.settingsStore.read(groupId, 'locations', () => request) : request;
    return source
      .pipe(tap(locations => this.locationsSubject.next(locations)));
  }

  /** Saves the whole list: rows left out are removed, rows without a saved id are added. */
  updateLocations(locations: any[]): Observable<any[]> {
    const token = localStorage.getItem('token');
    return this.http.put<any[]>(`${this.apiUrl}/locations`, { groupId: this.groupId, locations }, {
      headers: { Authorization: `Bearer ${token}` }
    }).pipe(tap(saved => this.locationsSubject.next(saved)));
  }
}
